import axios from 'axios';

import {
    addCoupon,
    getDeliveryDates,
    getPackagingVariants,
    getWrappingVariants,
    removeCoupon,
    setItemPackaging,
    setShippingMethod,
    submitPaybackNumber,
} from '@jsmdg/cart-library-ts';
import { createFragment } from '@jsmdg/react-fragment-scripts/fragment';
import { getTenantConfig } from '../shared/tenantConfig';
import { type RootComponentProps } from '../shared/types';
import { ProductDetailWrapper } from './components/ProductDetailWrapper';
import {
    addItemToCartAtUrl,
    createAddToCartButtonClickedEvent,
    fetchPlacesDetail,
    fetchPlacesSuggestions,
} from './services';
import { checkPaymentMethodAvailability } from './services/checkPaymentMethodAvailability';
import { createPaymentSession } from './services/createPaymentSession';
import { handleGetAvailabilities } from './services/handleGetAvailabilities';
import { validatePersonalInformation } from './services/validatePersonalInformation';
import { type ProductDetailContext } from './types/types';

async function initDependencies({ baseUrl }: { baseUrl?: string }): Promise<void> {
    axios.defaults.baseURL = await Promise.resolve(baseUrl);
}

const { Fragment, init } = createFragment<RootComponentProps, ProductDetailContext>(
    ProductDetailWrapper,
    ({ rootComponentProps }) => {
        const {
            algoliaConfig,
            customerState,
            featureFlagsVariation,
            initialReviews,
            initialWishlist,
            isBoxProductWithQrCodeLink,
            isMydays,
            isTopRecommendationEnabled,
            lastCheckUrlTemplate,
            locale,
            pageUrl,
            paymentServiceProviderConfig,
            product,
            price,
            reviewPartnerConfiguration,
            sharedData,
            tenant,
            xmasNoticesJson,
        } = rootComponentProps;

        return {
            addItemToCart: addItemToCartAtUrl,
            algoliaConfig,
            checkPaymentMethodAvailability,
            createAddToCartButtonClickedEvent,
            createPaymentSession,
            customerState,
            featureFlagsVariation,
            getPlacesDetail: async (placeId: string, sessionToken: string) =>
                fetchPlacesDetail({
                    placeId,
                    sessionToken,
                    locale,
                }),
            getPlacesSuggestions: async (input: string, sessionToken: string) =>
                fetchPlacesSuggestions({
                    input,
                    sessionToken,
                    locale,
                }),
            initialReviews,
            initialWishlist,
            isBoxProductWithQrCodeLink,
            isMydays,
            isTopRecommendationEnabled,
            locale,
            pageUrl,
            product,
            price,
            reviewPartnerConfiguration,
            tenant,
            tenantConfig: {
                ...getTenantConfig(tenant),
                ...sharedData,
            },
            xmasNoticesJson,
            handleGetAvailabilities,
            fetchPackagingVariants: getPackagingVariants,
            fetchWrappingVariants: getWrappingVariants,
            fetchDeliveryTerms: getDeliveryDates,
            lastCheckUrlTemplate,
            paymentServiceProviderConfig,
            updateItemPackaging: setItemPackaging,
            updateShippingMethod: setShippingMethod,
            addCoupon,
            removeCoupon,
            submitPaybackNumber,
            validatePersonalInformation,
        };
    },
    initDependencies,
);

export { Fragment, init };
